import { render, staticRenderFns } from "./Dimension.vue?vue&type=template&id=25cacf25&scoped=true"
import script from "./Dimension.vue?vue&type=script&lang=js"
export * from "./Dimension.vue?vue&type=script&lang=js"
import style0 from "./Dimension.vue?vue&type=style&index=0&id=25cacf25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cacf25",
  null
  
)

export default component.exports